import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Template } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

const TemplatesTableDeploymentsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Template>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{template.deploymentsCount}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplatesTableDeploymentsCell;
